import PropTypes from 'prop-types';
import {useMemo, useState, useEffect} from 'react';
import {useDebouncedEffect} from '@ozgene/gp5.hooks.use-debounced-effect';
import TextField from '@material-ui/core/TextField';
import {getStringChangeHandler} from '@ozgene/gp5.utils.data-functions';
import {validateUniqueName} from 'Teams/service/TeamService';

export default function UserEditor(props) {
  const {entity, onPropertyChange, onValidityChange} = props;
  const {name = ''} = entity;
  const [isValidating, setIsValidating] = useState(false);
  const [nameErrorText, setNameErrorText] = useState('');
  const handleChangeName = getStringChangeHandler('name', onPropertyChange);
  const isNameInvalid = useMemo(
    () => !name || !!nameErrorText,
    [name, nameErrorText],
  );

  useDebouncedEffect(
    () => {
      const validateName = async () => {
        setNameErrorText(await validateUniqueName(name));
        setIsValidating(false);
      };

      return validateName();
    },
    [name],
    500,
  );
  useEffect(() => setIsValidating(true), [name]);
  useEffect(
    () => onValidityChange(!isValidating && !isNameInvalid),
    [isValidating, isNameInvalid, onValidityChange],
  );

  return (
    <>
      <TextField
        fullWidth
        label="Name"
        type="text"
        value={name}
        onChange={handleChangeName}
        error={isNameInvalid}
        helperText={nameErrorText}
        inputProps={{maxLength: 50}}
      />
    </>
  );
}

UserEditor.propTypes = {
  entity: PropTypes.shape({
    name: PropTypes.string,
  }),
  onPropertyChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func.isRequired,
};
